import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Category from '../views/Category.vue'
import Post from '../views/Post.vue'
import Login from '../views/Login.vue'
import Apply_1 from '../views/Apply_1.vue'
import Apply_2 from '../views/Apply_2.vue'
import Apply_3 from '../views/Apply_3.vue'
import Progress from '../views/Progress.vue'
import Building from '../views/Building.vue'
import Order from '../views/Order.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Category/:CId',
    name: 'Category',
    component: Category
  },
  {
    path: '/Post/:PId/:CId?',
    name: 'Post',
    component: Post
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/Apply/1/:AId?',
    name: 'Apply_1',
    component: Apply_1,
  },
  {
    path: '/Apply/2/:AId?',
    name: 'Apply_2',
    component: Apply_2,
  },
  {
    path: '/Apply/3/:AId?',
    name: 'Apply_3',
    component: Apply_3,
  },
  {
    path: '/Progress',
    name: 'Progress',
    component: Progress,
  },
  {
    path: '/Building',
    name: 'Building',
    component: Building,
  },
  {
    path: '/Order',
    name: 'Order',
    component: Order,
  },
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
